import React from "react";
import PropTypes from "prop-types";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import useController from "./controller";
import useModalActions from "../../hooks/useModalActions";
import { MODAL_TYPES } from "../../utils/emitter";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function ExitModal({ onNegativeAction }) {
  ExitModal.propTypes = {
    onNegativeAction: PropTypes.func,
  };
  const { t } = useTranslation();
  const { onExit } = useController();
  const { closeModal } = useModalActions();
  return (
    <BaseModal
      title={t("modals.exit_game.title")}
      className="exit-modal little-mobile-modal"
      // description={t("modals.exit_game.return_in_game")}
      eventTypeModal={MODAL_TYPES.EXIT}
      descriptionStyle="exit-modal__desc"
    >
      <BaseButton onClick={onNegativeAction ? onNegativeAction : onExit}>
        {t("modals.exit_game.btn_exit")}
      </BaseButton>
      <BaseButton
        unfilledWhite
        className="modal-button-cancel"
        onClick={() => closeModal(MODAL_TYPES.EXIT)}
      >
        {t("modals.exit_game.btn_positive")}
      </BaseButton>
    </BaseModal>
  );
}
